<template>
  <div
      :class="classes"
      :style="overlayStyles"
  >
    <div
        v-for="(item, index) in params.data.items"
        :key="index"
        class="overlay-bo6-item"
        :class="{ 'is-completed': item.value === getCount }"
    >
      <div class="overlay-bo6-item__label">
        {{ item.label }}
      </div>
      <div
          class="overlay-bo6-item__value"
          :style="getStyles(item)"
      >
        <div class="content">
          <div
              v-if="item.value === getCount"
              class="completed"
          >
            <i class="icon-check"/>
          </div>
          <span> {{ item.value }} / {{ getCount }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WZOverlayBO6',

  props: {
    params: {
      type: Object,
      default: null,
    },
  },

  computed: {
    getCount() {
      if (this.params.tracker && this.params.tracker.startsWith('bo7')) {
        return 30;
      }
      return 33;
    },
    classes() {
      return [
        'overlay-bo6',
        `overlay-bo6--${this.params.styles.position}`,
        {
          'overlay-bo6--show-labels': this.params.styles.labelPosition !== 'off',
          'overlay-bo6--left-labels': this.params.styles.labelPosition === 'left',
          'overlay-bo6--right-labels': this.params.styles.labelPosition === 'right',
        },
      ];
    },

    overlayStyles() {
      return {
        '--border': `${this.params.styles.overlay.borderWidth}px`,
        '--size': `${this.params.styles.overlay.size}px`,
        '--color': `${this.params.styles.overlay.color}`,
        '--label-color': `${this.params.styles.overlay.labelColor}`,
        '--border-color': `${this.params.styles.overlay.borderColor}`,
        '--back-border-color': `${this.params.styles.overlay.borderColor2}`,
        '--border-radius': `${this.params.styles.overlay.borderRadius}px`,
      };
    },
  },

  methods: {
    getProgress(item) {
      return (item.value / this.count) * 100;
    },

    getStyles(item) {
      return {
        '--progress': `${this.getProgress(item)}%`,
        '--image': `url(${item.image})`,
      };
    },
  },
};
</script>

<style lang="scss">
.overlay-bo6 {
  padding: 20px;
  display: inline-flex;
  gap: calc(var(--border) * 2 + 8px);
  align-items: end;

  &--vertical {
    flex-direction: column;
  }

  &--horizontal {
    .overlay-bo6-item__label {
      display: none !important;
    }
  }

  &--show-labels {
    .overlay-bo6-item__label {
      display: block;
    }
  }

  &--left-labels {
    .overlay-bo6-item {
      flex-direction: row;
    }
  }

  &--right-labels {
    align-items: start;

    .overlay-bo6-item {
      flex-direction: row-reverse;
    }
  }

  /* stylelint-disable-next-line no-descending-specificity */
  &-item {
    position: relative;
    display: flex;
    align-items: center;
    gap: 15px;

    /* stylelint-disable-next-line no-descending-specificity */
    &__label {
      display: none;
      font-size: 18px;
      font-weight: 600;
      color: var(--label-color);
    }

    &__value {
      position: relative;
      width: var(--size);
      height: var(--size);
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: var(--border-radius);
      border: 0 solid #ddd;
      background: #000;

      .content {
        width: 100%;
        height: 100%;
        position: relative;
        background: #000;
        background-image: var(--image);
        background-position: center center;
        background-repeat: no-repeat;
        background-size: cover;
        font-weight: 600;
        font-size: 18px;
        z-index: 2;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: var(--border-radius);

        &::before {
          content: '';
          position: absolute;
          inset: 0;
          background: rgba(0, 0, 0, 0.3);
          border-radius: var(--border-radius);
          z-index: 3;
        }

        span {
          display: block;
          position: relative;
          z-index: 4;
          color: var(--color);
        }
      }

      &::before {
        content: '';
        position: absolute;
        left: calc(var(--border) * -1);
        top: calc(var(--border) * -1);
        right: calc(var(--border) * -1);
        bottom: calc(var(--border) * -1);
        background-color: transparent;
        z-index: -100;
        border: var(--border) solid var(--back-border-color);
        border-radius: calc(var(--border-radius) + 4px);
      }

      &::after {
        content: '';
        position: absolute;
        left: calc(var(--border) * -1);
        top: calc(var(--border) * -1);
        right: calc(var(--border) * -1);
        bottom: calc(var(--border) * -1);
        background-color: transparent;
        background-image: conic-gradient(
                var(--border-color),
                var(--border-color) var(--progress),
                transparent var(--progress)
        );
        z-index: 1;
        border-radius: calc(var(--border-radius) + 4px);
      }
    }

    &.is-completed {
      span {
        display: none;
      }

      .mask {
        background: rgba(0, 0, 0, 0.6);
      }
    }

    .completed {
      position: relative;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: var(--border-color);
      font-size: 38px;
      z-index: 25;
      padding-bottom: 10px;

      i {
        display: flex;
      }
    }
  }
}
</style>
